import React from 'react';
import PropTypes from 'prop-types';

import { GenericError } from '../GenericError';

function CreateAccountError({ onPrimary, errorDetails, tryCount }) {
	return (
		<GenericError
			onPrimary={() => {
				onPrimary(tryCount);
			}}
			errorDetails={errorDetails}
		/>
	);
}

CreateAccountError.propTypes = {
	errorDetails: PropTypes.shape({
		response: PropTypes.shape({
			coded_exceptions: PropTypes.arrayOf(
				PropTypes.shape({ error_status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
			),
		}),
	}),
	onPrimary: PropTypes.func.isRequired,
	tryCount: PropTypes.number.isRequired,
};

export { CreateAccountError };
